
import { Component, Prop, Vue} from "vue-property-decorator";
import timeRangeForNew from "@/helpers/cardInfoHelperFunctions/timeRangeForNew";

import GET_MANAGER_DB from "@/apollo/dashboard/GetManagerDB.gql";

import DashboardCardScaffold from "@/components/dashboard/cards/CardScaffold.vue";
import CardItemScaffold from "@/components/dashboard/cards/CardItemScaffold.vue";
import InvitationModalWithButton from "@/components/companyContractors/InvitationModalWithButton.vue";
import ManagerContractorDBIcon from "@/components/icons/ManagerContractorDBIcon.vue";
import SimplePersonIcon from "@/components/icons/SimplePersonIcon.vue";
import ItemChipsWithMore from "@/components/common/ItemChipsWithMore.vue";

import getSingularPluralForm from "@/helpers/cardInfoHelperFunctions/getSingularPluralForm";
import RouteNames from "@/entities/RouteNames";
import ItemChipsData from "@/entities/ItemChipsData";
import Roles from "@/entities/Roles";

@Component({
  components: {
    DashboardCardScaffold,
    InvitationModalWithButton,
    CardItemScaffold,
    ManagerContractorDBIcon,
    SimplePersonIcon,
    ItemChipsWithMore,
  },
  apollo: {
    managerDB: {
      query: GET_MANAGER_DB,
      variables() {
        return this.managerFilter;
      },
      update: (data) => data,
    }
  }
})
export default class DashboardManagerDB extends Vue {
  @Prop({type: String, required: true}) readonly companyId!: string;
  @Prop({type: String, required: true}) readonly currentUserId!: string;
  @Prop({type: String, required: true}) readonly currentUserRole!: string;
  @Prop({type: String, required: true}) readonly companyBusinessName!: string;

  managerDB: any = null;

  routes = RouteNames;

  get managerFilter(): object {
    const contractorCommonConditions = [
      { approved: { _eq: true } },
      { contractor : {
        _and: [
          { deleted: { _eq: false } },
          { approved: { _eq: true } },
        ],
      }},
    ];

    return {
      newContractorsFilter: {
        _and: [
          { updated_at: {_gt: timeRangeForNew(this.$moment) } },
          ...contractorCommonConditions
        ],
      },
      contractorsFilter: {
        _and: [
          ...contractorCommonConditions
        ],
      },
    };
  }

  get newContractorsText(): string {
    return `New ${getSingularPluralForm(this.newContractorsTotal, "Contractor", "Contractors")}`;
  }

  get isManager(): boolean {
    return this.currentUserRole === Roles.MANAGER;
  }

  get contractorsInfo(): ItemChipsData[]|string {
    if (!this.managerDB) {
      return [];
    }
    return this.managerDB.contractors.map(({contractor}: any) => {
      return {
        id: contractor.id,
        name: `${contractor.user.given_name} ${contractor.user.family_name}`,
        avatar: contractor.user.avatar,
      };
    });
  }

  get newContractorsInfo(): ItemChipsData[] {
    if (!this.managerDB) {
      return [];
    }

    const newContractors = this.managerDB.newContractors;
    if (!newContractors.length) {
      return [];
    }

    return newContractors.map(({contractor}: any) => {
      return {
        id: contractor.id,
        name: `${contractor.user.given_name} ${contractor.user.family_name}`,
        avatar: contractor.user.avatar,
      };
    });
  }

  get contractorsTotal(): number | undefined {
    if (!this.managerDB) {
      return undefined;
    }
    return this.managerDB.contractorsTotal.aggregate.count;
  }

  get newContractorsTotal(): number | undefined {
    if (!this.managerDB) {
      return undefined;
    }
    return this.managerDB.newContractorsTotal.aggregate.count;
  }
}
